<script setup lang="ts">
import { RouterWrapper } from '@bagelink/vue'
</script>

<template>
	<RouterWrapper />
</template>
